import * as t from '@/types'
import Routes from '@/routes'

const variables: t.Variable[] = [
  {
    name: 'Credit Card 1',
    type: t.VariableType.double,
    description: '',
    variable: 'Credit_Card_1_Bal',
    label: 'Balance',
    placeholder: '0.00',
    variable2: 'Credit_Card_1_Amt',
    label2: 'Repayments',
    placeholder2: '0.00',
    frequency: 'Credit_Card_1_Freq',
  },
  {
    name: 'Credit Card 2',
    type: t.VariableType.double,
    description: '',
    variable: 'Credit_Card_2_Bal',
    label: 'Balance',
    placeholder: '0.00',
    variable2: 'Credit_Card_2_Amt',
    label2: 'Repayments',
    placeholder2: '0.00',
    frequency: 'Credit_Card_2_Freq',
  },
  {
    name: 'Personal Loan 1',
    type: t.VariableType.double,
    description: '',
    variable: 'Personal_Loan_1_Bal',
    label: 'Balance',
    placeholder: '0.00',
    variable2: 'Personal_Loan_1_Amt',
    label2: 'Repayments',
    placeholder2: '0.00',
    frequency: 'Personal_Loan_1_Freq',
  },
  {
    name: 'Personal Loan 2',
    type: t.VariableType.double,
    description: '',
    variable: 'Personal_Loan_2_Bal',
    label: 'Balance',
    placeholder: '0.00',
    variable2: 'Personal_Loan_2_Amt',
    label2: 'Repayments',
    placeholder2: '0.00',
    frequency: 'Personal_Loan_2_Freq',
  },
  {
    name: 'Car Loan 1',
    type: t.VariableType.double,
    description: '',
    variable: 'Car_Loan_1_Bal',
    label: 'Balance',
    placeholder: '0.00',
    variable2: 'Car_Loan_1_Amt',
    label2: 'Repayments',
    placeholder2: '0.00',
    frequency: 'Car_Loan_1_Freq',
  },
  {
    name: 'Car Loan 2',
    type: t.VariableType.double,
    description: '',
    variable: 'Car_Loan_2_Bal',
    label: 'Balance',
    placeholder: '0.00',
    variable2: 'Car_Loan_2_Amt',
    label2: 'Repayments',
    placeholder2: '0.00',
    frequency: 'Car_Loan_2_Freq',
  },
  {
    name: 'Other',
    type: t.VariableType.double,
    description: '',
    variable: 'Debt_Other_Bal',
    label: 'Balance',
    placeholder: '0.00',
    variable2: 'Debt_Other_Amt',
    label2: 'Repayments',
    placeholder2: '0.00',
    frequency: 'Debts_Other_Freq',
  },
]

const name = 'Debt/Loans'
const title = 'Your Debts & Loans'
// tslint:disable-next-line
const description = "Sometimes we need those little digouts to cover things that are a little unexpected. Other times we choose to make some bigger purchases like cars etc on credit. Outline what debts you're managing and how much of your income goes on regular repayments."
const outro = ''
const link = Routes.step5

const stepDefinition: t.StepDefinition = {
  index: 5,
  name,
  title,
  description,
  variables,
  outro,
  link,
}

export default stepDefinition
